module.exports = __webpack_public_path__ + "static/04-69526b1f9ec018026975fe06cb090be7.jpg";